import type { Request, RequestExecute } from '../../../../api';
import PaginationOptions from '../../../../api/typedefs/sdk/PaginationOptions';

import getHelper from '../../../services/getHelper';
import ReportRequest from '../types/ReportRequest';
import ReportResponse from '../types/ReportResponse';

interface AnalyticsOptions extends PaginationOptions {
  reports?: ReportRequest[];
  asCsv?: boolean;
}

export default class AnalyticsHelper extends getHelper('/analytics/:id') {
  find(options: AnalyticsOptions): RequestExecute<ReportResponse>;

  find(options: AnalyticsOptions, directlyExecute: false): Request<ReportResponse>;

  find(options: AnalyticsOptions, directlyExecute: true): RequestExecute<ReportResponse>;

  find(
    { reports = [], asCsv = false }: AnalyticsOptions = {},
    directlyExecute: boolean = true
  ): Request<ReportResponse> | RequestExecute<ReportResponse> {
    // This is a POST request because we need to provide a big Request Body
    const request = super.create({ analyticItemRequests: reports }, false);

    if (asCsv) {
      request.setHeader('Accept', 'text/csv');
    }

    return directlyExecute ? request.execute() : request;
  }
}
